import { render, staticRenderFns } from "./PrintableField.vue?vue&type=template&id=5fc09296&scoped=true&"
import script from "./PrintableField.vue?vue&type=script&lang=js&"
export * from "./PrintableField.vue?vue&type=script&lang=js&"
import style0 from "./PrintableField.vue?vue&type=style&index=0&id=5fc09296&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc09296",
  null
  
)

export default component.exports